export enum CommunicationTables {
  CustomClaimSmsRequests = 'CustomClaimSmsRequests',
}
